import React from 'react'
import { Row, Col, Button, UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap'

function InstancesHeader({ onAdd, onExportExcel, onExportPdf, isExporting }) {
  return (
    <Row className="home-header align-items-center mb-4">
      <Col>
        <h1>Instancias</h1>
      </Col>
      <Col xs="auto" className="instances-header-actions">
        <UncontrolledDropdown>
          <DropdownToggle className="report-button" caret disabled={isExporting}>
            Report
          </DropdownToggle>
          <DropdownMenu end>
            <DropdownItem onClick={onExportExcel} disabled={isExporting}>
              Excel
            </DropdownItem>
            <DropdownItem onClick={onExportPdf} disabled={isExporting}>
              PDF
            </DropdownItem>
          </DropdownMenu>
        </UncontrolledDropdown>
        <Button className="add-button" onClick={onAdd}>
          + Anadir Instancia
        </Button>
      </Col>
    </Row>
  )
}

export default InstancesHeader
